import React, { useEffect } from 'react'
import { SelectSeeker } from '@ui-seeker/core'
import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData, useCsv } from 'Pages/ReportsAlerts/Reports/@signals'
import { array, object } from 'yup'
import { isEmpty } from '@ui-seeker/utils'


export default function DaySelector() {

	const {
		daysSelected,
		setDaysSelectedInfo,
		error
	} = useReportFormInfo(
		 reportFormData.peek().daysSelected,
		"daysSelected",
		object({
			daysSelected: array()
				.required("Must provide a week day")
				.min(1, "Must provide a week day")
		}))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setDaysSelectedInfo([], false)
		}
	}, [useCsv.value])

	return <SelectSeeker
		label="Days in Week"
		isClearable
		multiple
		options={[
			{ value: 0, label: "Monday" },
			{ value: 1, label: "Tuesday" },
			{ value: 2, label: "Wednesday" },
			{ value: 3, label: "Thursday" },
			{ value: 4, label: "Friday" },
			{ value: 5, label: "Saturday" },
			{ value: 6, label: "Sunday" },
		]}
		value={daysSelected || []}
		onChange={e => setDaysSelectedInfo(e.target.value)}
		error={error}
	/>
}